export default __webpack_public_path__ + "static/media/tinyDaoRight2.2baea300.png";